import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/performance_metrics_data_actions';
import { NavPageWrapper } from "../common/Nav";
import { default as PageLastLoaded } from "../common/PageLastLoaded";
import { default as PerformanceMetricsFilter } from "./PerformanceMetricsFilter";
import { default as PerformanceMetricsTable } from "./PerformanceMetricsTable";
import { default as PerformanceMetricsDetailView } from "./PerformanceMetricsDetailView";
import * as utilityHelpers from './shared/UtilityHelper';

export class PerformanceMetrics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDesktop: true,
      isPerformanceMetricsPage: true,
      width: window.innerWidth,
      isFilterModalOpen: false
    };

    this.toggleModal = this.toggleModal.bind(this);

    if(this.props.actions.fetchMUAction) {
      this.props.actions.fetchMUAction()
    }

    if(this.props.actions.fetchAgentAction) {
      this.props.actions.fetchAgentAction()
    }

    if(this.props.actions.fetchTeamAction) {
      this.props.actions.fetchTeamAction()
    }

    // closes detail view if user navigates to another tab and returns to performance metrics tab
    if(this.props.actions.closePerformanceMetricsDetailedView) {
      this.props.actions.closePerformanceMetricsDetailedView()
    }

    this.viewScorecard = this.viewScorecard.bind(this);
  }

  componentDidMount() {
    let scorecardSelectionKey = utilityHelpers._retrieveStorageKey(this.props.User);
    let items = localStorage[scorecardSelectionKey];
    
    if(items) {
      try {
        var arr = JSON.parse(items);
         let isValid = utilityHelpers._checkLocalStorageExpiration(arr.expirationDate);
        
         if(!isValid) {
           //reset selections and trigger a clearFilter()
            arr = {
              mu: [],
              agent: [],
              team: []
            }
            if(this.props.actions.notifyFilterOfSelections) {
              this.props.actions.notifyFilterOfSelections(arr)
            }
           return;
         }
        
        if(this.props.actions.notifyFilterOfSelections) {
          this.props.actions.notifyFilterOfSelections(arr)
        }
      }
      catch(e) { }
    }
  }

  toggleModal() {
    this.setState({ isFilterModalOpen: !this.state.isFilterModalOpen });
  }

  viewScorecard(gridName, itemId, itemName) {
    if(this.props.actions.viewPerformanceMetricsDetailedView) {
      this.props.actions.viewPerformanceMetricsDetailedView()
    }

    this.setState({ gridName: gridName, itemId: itemId, itemName: itemName })
  }

  render() {
    let { isPerformanceMetricsPage, isDesktop, isFilterModalOpen, gridName, itemId, itemName } = this.state;
    let { isTablet, isNotDesktop } = this.props;
    let c1 = (isTablet && isNotDesktop) || !isNotDesktop;

    return (
        <NavPageWrapper 
          currPath={this.props.match.path} 
          isTablet={isTablet} 
          isPerformanceMetricsPage={isPerformanceMetricsPage}
        >
          <div className="performance__metrics-page">
            
            <div className="subhdr-tab">
              <PageLastLoaded 
                isPerformanceMetricsPage={isPerformanceMetricsPage} 
                isDesktop={isDesktop}
              />
              { 
                isTablet ? 
                <div>
                  <div className={ isFilterModalOpen ? 'filter__modal' : ''}>
                    <div className={ isFilterModalOpen ? "filter__modal-close" : "filter__button" } onClick={this.toggleModal}>{ isFilterModalOpen ? '' : 'Filters' }</div>
                    <div className={ isFilterModalOpen ? "" : "hide"}>
                      <PerformanceMetricsFilter />
                    </div>
                  </div>
                </div> : "" 
              }
              <span className={ isTablet ? "hide" : "right note_text"}><strong>Note:</strong> Work day is defined as 3AM to 3AM Eastern</span>
            </div>
            
            { !c1 ?
              <div className={"performance__metrics-filter"}>
                <PerformanceMetricsFilter />
              </div> : ""
            }

            <div className={ isFilterModalOpen ? "hide" : "performance__metrics-table" }>
              <PerformanceMetricsTable 
                viewScorecard={ this.viewScorecard.bind(this) }
              />
              <PerformanceMetricsDetailView 
                gridName={ gridName } 
                itemId={ itemId }
                itemName={ itemName }
              />
            </div>
          </div>
      </NavPageWrapper>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isTablet: state.common.isTablet,
    isNotDesktop: state.common.isNotDesktop,
    User: state.common.user
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceMetrics);


// WEBPACK FOOTER //
// ./src/features/scorecard/PerformanceMetrics.js